




import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
    components: {
        WhiseSurface: () => import("./whise-surface.vue"),
        WhiseYesNo: () => import("./whise-yes-no.vue"),
        WhisePrice: () => import("./whise-price.vue"),
        WhiseGeneral: () => import("./whise-general.vue")
    }
})
export default class WhiseDetailPart extends Vue {
    @Prop() data?: WhiseDetail;

    get component(): string | false {
        if (!this.data) {
            return false;
        }

        switch (this.data.type) {
            case "surface":
                return "whise-surface";
            case "yes/no":
                return "whise-yes-no";
            case "price":
                return "whise-price";
            case "price":
                return "whise-year";
                break;
        }

        return 'whise-general';
    }
}
